export const BILLING_DOC_TYPES = ['CUIT', 'DNI'];

export const BILLING_TAX_CONDITIONS = [
    'CONSUMIDOR FINAL',
    'RESPONSABLE INSCRIPTO',
    'MONOTRIBUTO',
];

export const TUSFACTURAS_PROVINCES = [
    'CIUDAD AUTONOMA DE BUENOS AIRES',
    'BUENOS AIRES',
    'CATAMARCA',
    'CHACO',
    'CHUBUT',
    'CORDOBA',
    'CORRIENTES',
    'ENTRE RIOS',
    'FORMOSA',
    'JUJUY',
    'LA PAMPA',
    'LA RIOJA',
    'MENDOZA',
    'MISIONES',
    'NEUQUEN',
    'RIO NEGRO',
    'SALTA',
    'SAN JUAN',
    'SAN LUIS',
    'SANTA CRUZ',
    'SANTA FE',
    'SANTIAGO DEL ESTERO',
    'TUCUMAN',
];

export function digitsOnly(value) {
    return String(value || '').replace(/\D/g, '');
}

export function isValidCuit(raw) {
    const cuit = digitsOnly(raw);
    if (!/^\d{11}$/.test(cuit)) return false;
    const weights = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    const sum = weights.reduce((acc, weight, index) => acc + weight * Number(cuit[index]), 0);
    let dv = 11 - (sum % 11);
    if (dv === 11) dv = 0;
    if (dv === 10) dv = 9;
    return dv === Number(cuit[10]);
}

export function validateProfile(values) {
    const errors = {};
    const docType = values.docType;
    const taxCondition = values.taxCondition;
    const docNumber = digitsOnly(values.docNumber);

    if (!BILLING_DOC_TYPES.includes(docType)) errors.docType = 'Tipo inválido';
    if (docType === 'CUIT' && !isValidCuit(docNumber)) errors.docNumber = 'CUIT inválido';
    if (docType === 'DNI' && !/^\d{7,8}$/.test(docNumber)) errors.docNumber = 'DNI inválido';
    if (!BILLING_TAX_CONDITIONS.includes(taxCondition)) errors.taxCondition = 'Condición inválida';
    if (['RESPONSABLE INSCRIPTO', 'MONOTRIBUTO'].includes(taxCondition) && docType !== 'CUIT') {
        errors.docType = 'Esta condición fiscal exige CUIT';
    }
    if (!String(values.businessName || '').trim()) errors.businessName = 'Nombre o razón social obligatorio';
    if (!values.address) errors.address = 'Domicilio obligatorio';
    if (!TUSFACTURAS_PROVINCES.includes(values.province)) errors.province = 'Provincia inválida';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.billingEmail || '')) errors.billingEmail = 'Email inválido';
    return errors;
}
